function componetsLoadImages() {
  Image.prototype.load = function (url, callback) {
    var thisImg = this,
      xmlHTTP = new XMLHttpRequest()

    thisImg.completedPercentage = 0

    var bar = document.getElementById('bar-bg')
    var percent = document.querySelector('.js-percent-value')

    xmlHTTP.open('GET', url, true)
    xmlHTTP.responseType = 'arraybuffer'

    xmlHTTP.onload = function (e) {
      var h = xmlHTTP.getAllResponseHeaders(),
        m = h.match(/^Content-Type\:\s*(.*?)$/im),
        mimeType = m[1] || 'image/png'
      // Remove your progress bar or whatever here. Load is done.

      var blob = new Blob([this.response], { type: mimeType })
      thisImg.src = window.URL.createObjectURL(blob)
      if (callback) callback(this)
    }

    var prevValue = 0

    xmlHTTP.onprogress = function (e) {
      if (e.lengthComputable)
        thisImg.completedPercentage = parseInt((e.loaded / e.total) * 100)

      // Update your progress bar here. Make sure to check if the progress value
      // has changed to avoid spamming the DOM.
      // Something like:
      if (prevValue != thisImg.completedPercentage) {
        display_progress(thisImg.completedPercentage)
        prevValue = thisImg.completedPercentage
      }
    }

    xmlHTTP.onloadstart = function () {
      // Display your progress bar here, starting at 0
      thisImg.completedPercentage = 0
      var hash = window.location.hash
      if (hash === '#no-intro') {
        loadImagesSection()
      }
    }

    display_progress = function (percentage) {
      bar.style.width = thisImg.completedPercentage + '%'
      percent.textContent = thisImg.completedPercentage
    }

    xmlHTTP.onloadend = function () {
      // You can also remove your progress bar here, if you like.
      thisImg.completedPercentage = 100
      if ($('body.page-index').length === 0) {
        setTimeout(() => {
          $('.intro-progress-bar').hide()
          $('.intro__logo').hide()
          $('body').addClass('remove-loading-scene')
          $('body').removeClass('is-intro-active')
          loadImagesSection()
        }, 450)
      } else {
        $('.intro__image--boom').remove()
        setTimeout(() => {
          $('body').addClass('remove-loading-scene')
          if ($('body.page-index').length === 0) {
            $('body').removeClass('is-intro-active')
          }
        }, 450)

        setTimeout(() => {
          $('.intro__btn').addClass('is-active')
          loadImagesSection()
        }, 600)

        var hash = window.location.hash
        if (hash === '#no-intro') {
          $('body').addClass('remove-loading-scene')
          $('body').removeClass('is-intro-active')
          $('.intro').remove()
          $('.hero-index-section').addClass('is-active')
          loadIndexContent()
        }
      }
    }

    xmlHTTP.send()
  }

  var imgThor = new Image()
  var dataImg = $('.intro').data('img')
  imgThor.load(dataImg)
  if (
    dataImg != 'images/thor-uvod.webp' &&
    dataImg != 'images/thor-boom.webp?v=2'
  ) {
    if ($('#intro-div').length) {
      document.getElementById('intro-div').appendChild(imgThor)
      $('#intro-div img:last-child').addClass(
        'img--responsive img--full intro__image intro__image--lighting',
      )
    }
  }
}
